import { BaseBus } from "./BaseBus";

export class LabelPrintQueueBus extends BaseBus {
    constructor(data: LabelPrintQueueBus = null) {
        super(data);
    }
    labelPrintQueueId: any;
    labelTypeId: any;
    labelTemplateId: any;
    referenceId: any;
    referenceIdType: number;
    status: number;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
}
